// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1348":"38b247e7a05b7be8","3944":"43a35eace7cb350a","6438":"919096de16d75b19"}[chunkId] + ".css";
};